export default __webpack_public_path__ + "static/media/infinite1.3ba3a1dc.png";